import * as React from 'react'
import { ITripHistoryObject } from '../../types'
import Star from '../icons/ui/Star'
import Badge from '../ui/Badge'
import TripHistoryDetailSection from './TripHistoryDetailSection'

interface ITripHistoryRiderDetailsProps {
  trip: ITripHistoryObject
}

const TripHistoryRiderDetails = (props: ITripHistoryRiderDetailsProps) => {
  const trip = props.trip
  return (
    <TripHistoryDetailSection title='Rider'>
      <div className='flex'>
        <img className='circle mr1' src={trip.rider.image} width='40' height='40' />
        <div className='flex-auto flex justify-center flex-column'>
          <div className='flex h6 mb02 items-center bold'>
            {(trip.rider.firstName + ' ' + trip.rider.lastName).trim()}{' '}
            <span className='ml1 h6 flex items-center'>
              <Star className='svg-green mr1' height={16} width={16} />
              {trip.rider.rating}
            </span>
          </div>
          <div className='font-grey h6'>{trip.rider.phone}</div>
        </div>
      </div>
      <div className='h6 ml4 mt1'>
        <Badge label={trip.service.name} />
      </div>
    </TripHistoryDetailSection>
  )
}

export default TripHistoryRiderDetails



// WEBPACK FOOTER //
// ./src/components/trips/TripHistoryRiderDetails.tsx